/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TTLODelete,
    TTLODeleteFromJSON,
    TTLODeleteToJSON,
    TTLOListConfiguration,
    TTLOListConfigurationFromJSON,
    TTLOListConfigurationToJSON,
    TTLOListItemPaginationWrapper,
    TTLOListItemPaginationWrapperFromJSON,
    TTLOListItemPaginationWrapperToJSON,
    TTLOQuery,
    TTLOQueryFromJSON,
    TTLOQueryToJSON,
    TTLOState,
    TTLOStateFromJSON,
    TTLOStateToJSON,
    TTLOStateResponse,
    TTLOStateResponseFromJSON,
    TTLOStateResponseToJSON,
} from '../models';

export interface ApiTicketTLOV2TTLOV2ListDeleteTTLOBulkDeleteRequest {
    tTLODelete: Array<TTLODelete>;
}

export interface ApiTicketTLOV2TTLOV2ListListPostRequest {
    tTLOQuery?: TTLOQuery;
}

export interface ApiTicketTLOV2TTLOV2ListUpdateStateBulkPostRequest {
    tTLOState: Array<TTLOState>;
}

/**
 * no description
 */
export class TTLOV2ListApi extends runtime.BaseAPI {

    /**
     */
    async apiTicketTLOV2TTLOV2ListDeleteTTLOBulkDeleteRaw(requestParameters: ApiTicketTLOV2TTLOV2ListDeleteTTLOBulkDeleteRequest): Promise<runtime.ApiResponse<Array<TTLOStateResponse>>> {
        if (requestParameters.tTLODelete === null || requestParameters.tTLODelete === undefined) {
            throw new runtime.RequiredError('tTLODelete','Required parameter requestParameters.tTLODelete was null or undefined when calling apiTicketTLOV2TTLOV2ListDeleteTTLOBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2List/DeleteTTLOBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tTLODelete.map(TTLODeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TTLOStateResponseFromJSON));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListDeleteTTLOBulkDelete(requestParameters: ApiTicketTLOV2TTLOV2ListDeleteTTLOBulkDeleteRequest): Promise<Array<TTLOStateResponse>> {
        const response = await this.apiTicketTLOV2TTLOV2ListDeleteTTLOBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<TTLOListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2List/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListGetListConfigurationGet(): Promise<TTLOListConfiguration> {
        const response = await this.apiTicketTLOV2TTLOV2ListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListListPostRaw(requestParameters: ApiTicketTLOV2TTLOV2ListListPostRequest): Promise<runtime.ApiResponse<TTLOListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2List/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TTLOQueryToJSON(requestParameters.tTLOQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TTLOListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListListPost(requestParameters: ApiTicketTLOV2TTLOV2ListListPostRequest): Promise<TTLOListItemPaginationWrapper> {
        const response = await this.apiTicketTLOV2TTLOV2ListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListUpdateStateBulkPostRaw(requestParameters: ApiTicketTLOV2TTLOV2ListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<TTLOStateResponse>>> {
        if (requestParameters.tTLOState === null || requestParameters.tTLOState === undefined) {
            throw new runtime.RequiredError('tTLOState','Required parameter requestParameters.tTLOState was null or undefined when calling apiTicketTLOV2TTLOV2ListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTLOV2/TTLOV2List/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tTLOState.map(TTLOStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TTLOStateResponseFromJSON));
    }

    /**
     */
    async apiTicketTLOV2TTLOV2ListUpdateStateBulkPost(requestParameters: ApiTicketTLOV2TTLOV2ListUpdateStateBulkPostRequest): Promise<Array<TTLOStateResponse>> {
        const response = await this.apiTicketTLOV2TTLOV2ListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
